export default __webpack_public_path__ + "static/media/instruction.4fa8bc53.svg";